// extracted by css-extract-rspack-plugin
export default {"scrollableUserList":"UsersList-module__scrollableUserList__Y5EJLFh"};